module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_9-dad2d5e2c5ab12915e78676341abac1c.jpg";